import { css } from "@vitality-ds/system";
export default css({
  gap: "$md",
  display: "flex",
  flex: 1,
  alignItems: "flex-start",
  justifyContent: "flex-end",
  variants: {
    size: {
      blockCompact: {
        flexGrow: 0
      },
      compact: {},
      "default": {}
    }
  }
});